import { computed, watch, ref } from 'vue'
import { useAppStore, searchStore } from '@/store/app'

/**
 * @description tab切换
 * @returns
 */
const useNavigation = (route, router) => {
  const store = useAppStore()
  const useSearchStore = searchStore()
  const activeFullPath = computed(() => store.activeFullPath)
  const tabList = computed(() => store.tabList)

  /** 当前激活tab索引 */
  const current = ref(0)

  /** 当前激活tab信息 */
  const currentTab = ref({})

  // 根据名字找到在tabList中的位置
  const getCurrentIndex = (path) => {
    const index = tabList.value.findIndex((item) => item.fullPath === path)
    return index
  }

  const setCurrent = () => {
    const index = getCurrentIndex(activeFullPath.value)
    if (index !== -1) {
      current.value = index
      currentTab.value = tabList.value[index]
    }
    // 如果当前页不是tab激活页，跳转
    if (route.value.fullPath !== activeFullPath.value) {
      router.push({
        name: currentTab.value.name,
      })
    }
  }

  setCurrent()

  /**
   *
   * @describe 切换路由回调
   * @param {*} route 路由信息
   */
  const selectMenu = (currentRoute) => {
    // 加入keepalive缓存
    store.addKeepAliveCache(currentRoute.name)
    const submenu = {
      path: currentRoute.path,
      name: currentRoute.name,
      label: currentRoute.meta.tabName,
      fullPath: currentRoute.fullPath,
      group: currentRoute.meta.group ? currentRoute.meta.group : '',
      canEdit: currentRoute.meta.canEdit,
    }
    store.selectMenu(submenu, current.value)
  }

  /**
   *
   * @describe 切换激活tab
   * @param {*} item 路由信息
   */
  const changeMenu = (item) => {
    // 首先判断点击的是否是自己，如果是自己则return
    if (store.activeFullPath === item.fullPath) {
      return
    }

    // 存储标签
    store.changeMenu(item)
    // 页面跳转
    router.push({ path: item.fullPath })
  }

  watch(
    () => route.value,
    (val) => {
      selectMenu(val)

      setCurrent()
    }
  )

  const visible = ref(false)
  const shouldNotice = (tab) => {
    if (tab?.canEdit) {
      visible.value = true
      return true
    }
    return false
  }

  // const resolveFn = []

  /**
   * @describe 确认关闭
   */
  const handleConfirm = () => {
    visible.value = false

    const tab = currentTab.value
    const index = current.value
    // 将其从标签List中移除
    const oldActiveFullPath = store.activeFullPath
    // 点击tab在tabList中位置
    const clickTabIndex = getCurrentIndex(tab.fullPath)
    // 当前选中tab在tabList中位置
    const currentTabIndex = getCurrentIndex(activeFullPath.value)

    // 之前的tabList
    const oldTabList = store.tabList
    const length = oldTabList.length - 1

    const newTabList = oldTabList.filter(
      (item) => item.fullPath !== tab.fullPath
    )

    // 删除keepAlive缓存
    store.removeKeepAliveCache(tab.name)

    // 关闭tab不是当前tab
    if (tab.fullPath !== oldActiveFullPath) {
      // 点击tab在currentTab左侧，需手动切换current值
      if (clickTabIndex < currentTabIndex) {
        current.value -= 1
      }
      store.closeTab({
        activeFullPath: oldActiveFullPath,
        tabList: newTabList,
      })
      // if (resolveFn.length) {
      //   resolveFn.forEach((fn) => fn())
      // }
      // resolveFn = []
      return
    }

    // 根据标签位置决定跳转方向、更新当前激活标签、更新标签List(点击最后一个时向左跳转)
    if (index === length) {
      const newActiveFullPath = newTabList[index - 1].fullPath
      store.closeTab({
        activeFullPath: newActiveFullPath,
        tabList: newTabList,
      })
      router.push({
        path: newTabList[index - 1].fullPath,
      })
    } else {
      const newActiveFullPath = newTabList[index].fullPath
      store.closeTab({
        activeFullPath: newActiveFullPath,
        tabList: newTabList,
      })
      router.push({
        path: newTabList[index].fullPath,
      })
    }

    // if (resolveFn.length) {
    //   resolveFn.forEach((fn) => fn())
    // }
    // resolveFn = []
  }

  /**
   * @describe 关闭某个tab
   * @param {*} tab
   * @param {*} index
   */
  const handleClose = (tab) => {
    if (tab.label === 'TRIBE Detail') {
      useSearchStore.clearTabSearch(tab.fullPath.split('=')[1])
    }
    currentTab.value = tab

    if (shouldNotice(tab)) return

    handleConfirm()

    // if (index === 0) return
    // await new Promise((resolve) => {
    //   currentTab.value = tab

    //   resolveFn.push(resolve)
    //   if (shouldNotice(tab)) return

    //   handleConfirm()

    // })
  }

  /**
   * @describe 关闭其他标签页
   */
  const handleCloseOtherTab = (index) => {
    // for (let i = 0; i < tabList.value.length; i++) {
    //   if (i !== index) {
    //     console.log(`第${i}次执行`)
    //     // eslint-disable-next-line no-await-in-loop
    //     await handleClose(tabList.value[i], i)
    //   }
    // }
    // todo
    store.closeOtherTab(index)
    current.value = 0
    if (route.value?.fullPath !== tabList.value[0]?.fullPath) {
      router.push({
        path: tabList.value[0].fullPath,
      })
    }
  }
  /**
   * @describe 关闭右侧标签页
   */
  const handleCloseRightTab = (index) => {
    store.closeRightTab(index)
    // 关闭位置在当前激活tab左侧
    if (index < current.value) {
      current.value = index
      router.push({
        path: tabList.value[index].fullPath,
      })
    }
  }
  /**
   * @describe 关闭左侧标签页
   */
  const handleCloseLeftTab = (index) => {
    store.closeLeftTab(index)
    current.value -= index
  }
  return {
    activeFullPath,
    tabList,
    current,
    setCurrent,

    visible,
    selectMenu,
    changeMenu,
    handleClose,
    handleConfirm,

    handleCloseOtherTab,
    handleCloseRightTab,
    handleCloseLeftTab,
  }
}

export default useNavigation
